const fillNullCashflowData = (data, years, category) => {
  if (!(years instanceof Map) || years.size < 1) {
    throw new Error('Invalid years')
  } else if (!Array.isArray(data)) {
    throw new Error('Invalid data')
  }
  const availableYears = data.map(datum => datum.year)
  const filledData = []
  const hasData = {}
  for (const datum of data) {
    if (!hasData[datum.year]) {
      hasData[datum.year] = datum
    } else if (datum.createdAt > hasData[datum.year].createdAt && datum.category !== 'tax_transcript') { // this probably has implications in displaying diffs/discrepancies
      hasData[datum.year] = datum
    }
  }
  for (const year of Array.from(years.keys())) {
    const y = parseInt(year, 10)
    const { period } = years.get(year)
    if (availableYears.indexOf(y) < 0) {
      filledData.push({ year: y, data: null, category, period })
    } else {
      filledData.push(hasData[year])
    }
  }
  return filledData.sort((a, b) => a.year - b.year)
}

export default fillNullCashflowData